import scriptLoader from '@wetransfer/transfer/helper/script-loader';

export const init = async ({ src, scriptText, HTMLAttributes, async }) => {
  await scriptLoader(src, { scriptText, HTMLAttributes, async });
};
